export default __webpack_public_path__ + "static/media/Stats_Addons.69a5dd58.svg";